import React from "react";

// import ConsultingAndReviewingDocuments from "./../images/home/consulting_and_reviewing_documents.svg";
// import Complaints from "./../images/home/complaints.svg";
// import ContractWriting from "./../images/home/contract_writing.svg";
// import International from "./../images/home/international.svg";
// import Petition from "./../images/home/petition.svg";

import ConsultingAndReviewingDocuments from "./../images/services/consulting_and_reviewing_documents.svg";
import Complaints from "./../images/services/complaints.svg";
import ContractWriting from "./../images/services/contract_writing.svg";
import International from "./../images/services/international.svg";
import Petition from "./../images/services/petition.svg";
import advocacy_acceptation from "./../images/services/advocacy_acceptation.svg";
import dedicated_services from "./../images/services/dedicated_services.svg";

export const ProfileReduxTypes = {
  FETCH_PROFILE: "FETCH_PROFILE",
  FETCH_PROFILE_SUCCESS: "FETCH_PROFILE_SUCCESS",
  FETCH_PROFILE_FAILURE: "FETCH_PROFILE_FAILURE",
  update: "PROFILE_Profile_Update",
  update_failed: "PROFILE_Update_failed",
  logout: "PROFILE_Logout",
};

export const settingReduxTypes = {
  SET_UNREAD_STATUS: "FETCH_SET_UNREAD_STATUSPROFILE",
};

// export const VoiceCallType = {
//   voice_call: {
//     key: "voice_call",
//     value: "مشاوره تلفنی (بتا)",
//     url: "/consulting/voice-call",
//     icon: <img src={ConsultingAndReviewingDocuments} alt={"مشاوره حقوقی"} />,
//     description:
//       "این خدمت مانند یک جلسه مشاوره در دفتر وکالت بوده و وکیل به کلیه پرسشهای حقوقی شما پاسخ می دهد. همچنین اگر سند یا قراردادی در اختیار شماست و نیاز به مشورت با وکیل دارید این خدمت را انتخاب کنید و توجه داشته باشید که در صورت انتخاب این خدمت وکیل تنها به پرسشهای حقوقی شما پاسخ می دهد: لذا اگر تقاضای نگارش قرارداد، تنظیم لایحه و یا دادخواست دارید خدمات مربوطه را انتخاب نمایید. در انتخاب موضوع دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید.",
//   }
// };

export const RootCategoriesTypes = {
  consulting_and_reviewing_documents: {
    key: "consulting_and_reviewing_documents",
    value: "مشاوره حقوقی",
    url: `/consulting/consulting_and_reviewing_documents`,
    icon: <img src={ConsultingAndReviewingDocuments} alt={"مشاوره حقوقی"} />,
    description:
      "این خدمت مانند یک جلسه مشاوره در دفتر وکالت بوده و وکیل به کلیه پرسشهای حقوقی شما پاسخ می دهد. همچنین اگر سند یا قراردادی در اختیار شماست و نیاز به مشورت با وکیل دارید این خدمت را انتخاب کنید و توجه داشته باشید که در صورت انتخاب این خدمت وکیل تنها به پرسشهای حقوقی شما پاسخ می دهد: لذا اگر تقاضای نگارش قرارداد، تنظیم لایحه و یا دادخواست دارید خدمات مربوطه را انتخاب نمایید. در انتخاب موضوع دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید.",
  },
  // contract_writing: {
  //   key: "contract_writing",
  //   value: "نگارش قرارداد",
  //   url: `/consulting/contract_writing`,
  //   icon: <img src={ContractWriting} alt={"نگارش قرارداد"} />,
  //   description:
  //     "اگر قصد معامله یا تنظیم قرارداد دارید این خدمت را انتخاب کنید. با توجه به اطلاعاتی که در اختیار وکیل قرار می دهید، متن قرارداد آماده و برای شما ارسال می گردد." +
  //     "ارتباط شما با وکیل برای مدت 48 ساعت برقرار می باشد: بنابراین در اسرع وقت کلیه اطلاعات لازم را در اختیار وکیل قرار دهید تا وکیل بر مبنای اطلاعات داده شده، متن قرارداد را تنظیم نماید. در انتخاب موضوع قرارداد دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید. در صورتی که قادر به تشخیص عنوان مرتبط نیستید، لطفا ارجاع توسط پشتیبان را انتخاب نمایید.",
  // },
  // petition: {
  //   key: "petition",
  //   value: "تنظیم دادخواست و لوایح حقوقی",
  //   url: `/consulting/petition`,
  //   icon: <img src={Petition} alt={"تنظیم دادخواست و لوایح حقوقی"} />,
  //   description:
  //     "اگر قصد اقامه دعوای حقوقی داشته و یا در جریان دادرسی نیاز به تنظیم لایحه تخصصی جهت ارایه به دادگاه دارید، این خدمت را انتخاب نمایید؛ ارتباط شما با وکیل برای مدت 48 ساعت برقرار می باشد: بنابراین در اسرع وقت کلیه اطلاعات لازم را در اختیار وکیل قرار دهید تا وکیل بر مبنای اطلاعات داده شده، متن دادخواست و لایحه را تنظیم نماید. در انتخاب موضوع قرارداد دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید. در صورتی که قادر به تشخیص عنوان مرتبط نیستید، لطفا ارجاع توسط پشتیبان را انتخاب نمایید.",
  // },
  // complaints: {
  //   key: "complaints",
  //   value: "تنظیم شکواییه و لوایح کیفری",
  //   url: `/consulting/complaints`,
  //   icon: <img src={Complaints} alt={"تنظیم شکواییه و لوایح کیفری"} />,
  //   description:
  //     "اگر قصد اقامه دعوای کیفری داشته و یا در جریان دادرسی نیاز به تنظیم لایحه تخصصی جهت ارایه به دادسرا ویا دادگاه دارید، این خدمت را انتخاب نمایید؛ ارتباط شما با وکیل برای مدت 48 ساعت برقرار می باشد: بنابراین در اسرع وقت کلیه اطلاعات لازم را در اختیار وکیل قرار دهید تا وکیل بر مبنای اطلاعات داده شده، متن شکواییه و لایحه را تنظیم نماید. در انتخاب موضوع قرارداد دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید. در صورتی که قادر به تشخیص عنوان مرتبط نیستید، لطفا ارجاع توسط پشتیبان را انتخاب نمایید.",
  // },
  advocacy_acceptation: {
    key: "advocacy_acceptation",
    value: " وکالت در دادگاه",
    url: `/consulting/advocacy_acceptation`,
    icon: <img src={advocacy_acceptation} alt={"وکالت در دادگاه"} />,
    description:
      "اگر قصد انتخاب وکیل دادگستری را دارید تا وکالت شما را در دادگاه عهده دار شود، این خدمت را انتخاب نمایید و پس از آن تقاضای خود را به طور مختصر شرح دهید و مدارک خود را نیز ارسال نمایید. منتظر تماس همکاران ما در صفحه چت و یا تماس تلفنی باشید.",
  },
  dedicated_services: {
    key: "dedicated_services",
    value: "بسته‌های ویژه مشاوره",
    url: `/consulting/dedicated_services`,
    icon: <img src={dedicated_services} alt={"بسته‌های ویژه مشاوره"} />,
    description:
      "با انتخاب هریک از بسته های ویژه، ارتباط شما برای مدت زمان اعتبار بسته (۱۵-۲۰-۳۵-۴۵-۶۰ روز) با یکی از وکلای منتخب لاوین برقرار می شود شما می توانید در مورد تمام سوالات حقوقی خود در موضوعات مختلف با وکیل مشورت نمایید توجه داشته باشید زمان بسته یا مدت اعتبار آن هر کدام که زودتر منقضی شود به منزله پایان یافتن بسته می باشد",
  },
  contracts_and_judicial_documents: {
    key: "contracts_and_judicial_documents",
    value: "قرارداد،‌ دادخواست و شکواییه",
    url: `/consulting/contracts_and_judicial_documents`,
    icon: <img src={ContractWriting} alt={"قرارداد،‌ دادخواست و شکواییه"} />,
    description:
      "اگر تقاضای شما تنظیم قرارداد، دادخواست، شکوائیه و لایحه توسط وکیل می باشد، این خدمت را انتخاب نمایید و شرح تقاضا و مدارک خود را در اسرع وقت در صفحه چت ارسال فرمایید. ارتباط شما برای مدت 48 ساعت با وکیل برقرار می باشد و وکیل حداکثر تا پایان مدت متن نهایی را برای شما ارسال خواهد نمود.",
  },
  international: {
    key: "international",
    value: "حقوق بازرگانی بین المللی",
    url: `/consulting/international`,
    icon: <img src={International} alt={"حقوق بازرگانی بین المللی"} />,
    description:
      "این خدمت پاسخگوی نیازهای حقوقی بین المللی شماست." +
      "اگر نیاز به مشاوره حقوقی در زمینه بازرگانی بین المللی، سرمایه گذاری خارجی، نگارش قرارداد بین المللی، موضوعات مالی و بانکی بین المللی داشته و یا نیاز به ترجمه تخصصی اسناد و مدارک دارید، این خدمت را انتخاب نمایید. در انتخاب موضوع قرارداد دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید.",
  },
  call: {
    key: "call",
    value: "مشاوره تلفنی",
    url: `/consulting/call`,
    icon: <img src={ConsultingAndReviewingDocuments} alt={"مشاوره تلفنی"} />,
    description:
      "این خدمت مانند یک جلسه مشاوره در دفتر وکالت بوده و وکیل به کلیه پرسشهای حقوقی شما پاسخ می دهد. همچنین اگر سند یا قراردادی در اختیار شماست و نیاز به مشورت با وکیل دارید این خدمت را انتخاب کنید و توجه داشته باشید که در صورت انتخاب این خدمت وکیل تنها به پرسشهای حقوقی شما پاسخ می دهد: لذا اگر تقاضای نگارش قرارداد، تنظیم لایحه و یا دادخواست دارید خدمات مربوطه را انتخاب نمایید. در انتخاب موضوع دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید.",
  },
};

export const ContractsAndJudicialDocumentsTypes = {
  contract_writing: {
    key: "contract_writing",
    value: "نگارش قرارداد",
    url: `/consulting/contract_writing`,
    icon: <img src={ContractWriting} alt={"نگارش قرارداد"} />,
    description:
      "اگر قصد معامله یا تنظیم قرارداد دارید این خدمت را انتخاب کنید. با توجه به اطلاعاتی که در اختیار وکیل قرار می دهید، متن قرارداد آماده و برای شما ارسال می گردد." +
      "ارتباط شما با وکیل برای مدت 48 ساعت برقرار می باشد: بنابراین در اسرع وقت کلیه اطلاعات لازم را در اختیار وکیل قرار دهید تا وکیل بر مبنای اطلاعات داده شده، متن قرارداد را تنظیم نماید. در انتخاب موضوع قرارداد دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید. در صورتی که قادر به تشخیص عنوان مرتبط نیستید، لطفا ارجاع توسط پشتیبان را انتخاب نمایید.",
  },
  petition: {
    key: "petition",
    value: "تنظیم دادخواست و لوایح حقوقی",
    url: `/consulting/petition`,
    icon: <img src={Petition} alt={"تنظیم دادخواست و لوایح حقوقی"} />,
    description:
      "اگر قصد اقامه دعوای حقوقی داشته و یا در جریان دادرسی نیاز به تنظیم لایحه تخصصی جهت ارایه به دادگاه دارید، این خدمت را انتخاب نمایید؛ ارتباط شما با وکیل برای مدت 48 ساعت برقرار می باشد: بنابراین در اسرع وقت کلیه اطلاعات لازم را در اختیار وکیل قرار دهید تا وکیل بر مبنای اطلاعات داده شده، متن دادخواست و لایحه را تنظیم نماید. در انتخاب موضوع قرارداد دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید. در صورتی که قادر به تشخیص عنوان مرتبط نیستید، لطفا ارجاع توسط پشتیبان را انتخاب نمایید.",
  },
  complaints: {
    key: "complaints",
    value: "تنظیم شکواییه و لوایح کیفری",
    url: `/consulting/complaints`,
    icon: <img src={Complaints} alt={"تنظیم شکواییه و لوایح کیفری"} />,
    description:
      "اگر قصد اقامه دعوای کیفری داشته و یا در جریان دادرسی نیاز به تنظیم لایحه تخصصی جهت ارایه به دادسرا ویا دادگاه دارید، این خدمت را انتخاب نمایید؛ ارتباط شما با وکیل برای مدت 48 ساعت برقرار می باشد: بنابراین در اسرع وقت کلیه اطلاعات لازم را در اختیار وکیل قرار دهید تا وکیل بر مبنای اطلاعات داده شده، متن شکواییه و لایحه را تنظیم نماید. در انتخاب موضوع قرارداد دقت نمایید تا به وکلای متخصص در آن رشته ارجاع شوید. در صورتی که قادر به تشخیص عنوان مرتبط نیستید، لطفا ارجاع توسط پشتیبان را انتخاب نمایید.",
  },
};

export const MessageReduxType = {
  add: "Messages_Add",
  addBulk: "Messages_Add_Bulk",
  deleted: "Messages_Deleted",
  cancel: "Messages_Cancel",
  update: "Messages_Update",
  updateStatus: "Messages_Update_Status",
  updateData: "Messages_Update_Data",
  updateTime: "Messages_Update_Time",
  updateReply: "Messages_Update_Reply",
  updateTemp: "Messages_Update_Temp",
  updateType: "Messages_Update_Type",
  updateVoice: "Messages_Update_Voice",
  loading: "Messages_Loading_Type",
};

export const MessageType = {
  client: {
    text: "client.Text",
    voice: "client.Voice",
    image: "client.Image",
    media: "client.media",
    call: "client.call",
  },
  support: {
    text: "support.Text",
    voice: "support.Voice",
    media: "support.media",
    rate: "support.rate",
    call: "support.call",
  },
  lawyer: {
    text: "lawyer.Text",
    voice: "lawyer.Voice",
    image: "lawyer.Image",
    media: "lawyer.media",
    call: "lawyer.call",
  },
};

export const MessageStatus = {
  ready: "ready",
  failed: "failed",
  cancel: "cancel",
  sending: "sending",
  downloadable: "downloadable",
  retry: "retry",
  seen: "seen",
  delete: "deleted",
};

export const MessageServerConstant = {
  text: "TEXT",
  voice: "VOICE",
  document: "DOCUMENT",
  commented_document: "COMMENTED_DOCUMENT",
  images: "IMAGE",
  text_rate: "TEXT_RATE",
  call: "CALL",
};

export const ApiStatus = {
  done: "done",
  loading: "loading",
  error: "error",
};

export const BatteryStatus = {
  dead: "dead",
  nope: "nope",
  low: "low",
  mid: "mid",
  high: "high",
};

export const SessionStatus = {
  RECHARGE_NEEDED: "RECHARGE_NEEDED",
  CLOSED_BY_ADMIN: "CLOSED_BY_ADMIN",
  STARTED: "STARTED",
  READY_FOR_PAYMENT: "READY_FOR_PAYMENT",
  LOOKING_FOR_LAWYER: "LOOKING_FOR_LAWYER",
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  WAITING_FOR_CATEGORY: "WAITING_FOR_CATEGORY",
};

export const DiscountType = {
  PERCENT: "percent",
  VALUE: "value",
};

export const termsUrl = `https://lawin.co/terms-client`;
export const privacyUrl = `https://lawin.co/privacy-policy`;
